import { BaseWidget } from '@website-builder/widgets/base/base-widget';
import { GeneralStyle } from '@website-builder/model/style/general-style';

export abstract class BaseMultipleWidget<T, TStyle extends GeneralStyle = GeneralStyle> extends BaseWidget<TStyle> {
  elements: T[];
}
